(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build_own_bundle"] && !Shopify.designMode) return;
  try {
    
  // console.log(' ================== Bundle Code Start 1  ================== ');
  const setVariant = setInterval(function () {
    $('.build_own_bundle_section .slot_toggle #slot_toggle_pack_1').click();
  }, 50);
  setTimeout(function () {
    clearInterval(setVariant);
  }, 2000);

  // Update the Bundle Product review Count
  function reviewSet() {
    if ($('.shopify-block.shopify-app-block .loox-trust-badge-widget-ratings__raters-count').length !== 0) {
      const app_reviewCount = $('.shopify-block.shopify-app-block .loox-trust-badge-widget-ratings__raters-count').text();
      $('.bundle_product_review .loox-rating-label').text(`(${app_reviewCount})`);
      $('.customer_reviews_sec .customers-btn .review_count').text(app_reviewCount);
      clearInterval(intervalId);
    }
  }
  const intervalId = setInterval(reviewSet, 1000);
  setTimeout(function () {
    clearInterval(intervalId);
  }, 10000);

  // Check if there are elements with the class .save_badge
  // $('.build_own_bundle_section .save_badge').prependTo('.build_own_bundle_section .price .price__container');

  const buildOwnBundleSection = document.querySelector('.build_own_bundle_section');
  const customAddToCartBTN = document.querySelector('.build_own_bundle_section .custom_addToCartBtn');
  const addToCartBTN = document.querySelector('.build_own_bundle_section .product-form__submit');
  const atc_btn_text = $('.build_own_bundle_section .product-form__submit').text().trim();
  const atc_btn = document.querySelector('.build_own_bundle_section .atc_btn');

  // Define a function that returns a promise for the AJAX call
  function addToCartAsync(items) {
    //return new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: 'https://' + window.mu_origin + '/cart/add.js',
        data: JSON.stringify({ items: items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function (response) {
          // alert("Items Added");
          addToCartBTN.click();
          $(".custom_addToCartBtn .loading-overlay__spinner, .atc_btn .loading-overlay__spinner").addClass("hidden")
          customAddToCartBTN.disabled = false;
          // addToCartBTN.disabled = false;
          atc_btn.disabled = false;
          //resolve(response);
        },
        error: function (xhr, textStatus, errorThrown) {
          // alert("Get Error!");
          reject({ textStatus, errorThrown, response: xhr.responseText });
        }
      });
   // });
  }


  function addToCartCustom(from) {
    const resultsproduct = [...new Map(selected_product.map((m) => [m.product_id, m])).values()];
    var product_vid = from.find('input[name="id"]').val();
    var selling_plan = from.find('input[name="selling_plan"]').val();




        if(resultsproduct[0] != null ){

        var product_title_1 = resultsproduct[0].product_title
        var _pvgid_1 = resultsproduct[0]._pvgid
        var product_count_1 = resultsproduct[0].product_count

        }
       if( resultsproduct[1] != null){

        var product_title_2 = resultsproduct[1].product_title
        var _pvgid_2 = resultsproduct[1]._pvgid
        var product_count_2 = resultsproduct[1].product_count

        } 
        
        if( resultsproduct[2] != null){

          var product_title_3 = resultsproduct[2].product_title
          var _pvgid_3 = resultsproduct[2]._pvgid
          var product_count_3 = resultsproduct[2].product_count

        }
        
        if( resultsproduct[3] != null){

            var product_title_4 = resultsproduct[3].product_title
            var _pvgid_4 = resultsproduct[3]._pvgid
            var product_count_4 = resultsproduct[3].product_count

        }
        
        if( resultsproduct[4] != null){

              var product_title_5 = resultsproduct[4].product_title
              var _pvgid_5 = resultsproduct[4]._pvgid
              var product_count_5 = resultsproduct[4].product_count

            }


      var data = {
          [product_title_1] : product_count_1,
          [_pvgid_1] : product_count_1,

          [product_title_2] : product_count_2,
          [_pvgid_2] : product_count_2,

          [product_title_3] : product_count_3,
          [_pvgid_3] : product_count_3,

          [product_title_4] : product_count_4,
          [_pvgid_4] : product_count_4,

          [product_title_5] : product_count_5,
          [_pvgid_5] : product_count_5
  
      }



      let formData = {};

       if(selling_plan > 0){

       formData = {
        'id':  parseInt(product_vid, 10),
        'quantity': 1,
        "selling_plan" : selling_plan,
        'properties': data
       };


       }else{
      formData = {
              'id':  parseInt(product_vid, 10),
              'quantity': 1,
              'properties': data
            };

       }


       var items = [];
       items.push(formData);


      $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          data: JSON.stringify({ items: items }),
          contentType: 'application/json',
          dataType: 'json', 
          success: function(data) {
            const monster_active = !!document.querySelector('script[src*="/cart_renderer."]');
          if(monster_active) window.monster_refresh();
          openCart();


          },
          error: 'addToCartFail'
      });



  }






  $(document).ready(function () {
    let sellingPlanID = document.getElementById('sellingPlanData').dataset.sellingPlanId;
    $(`[name="selling_plan"]`).val(sellingPlanID);
    $('[name="selling_plan"]').prop('disabled', false);
      
    $(".build_own_bundle_section .custom_addToCartBtn").on("click", async function () {
      customAddToCartBTN.disabled = true;
      // addToCartBTN.disabled = true;
      atc_btn.disabled = true;
      $(".custom_addToCartBtn .loading-overlay__spinner, .atc_btn .loading-overlay__spinner").removeClass("hidden")
      let addToCartData = [];
      selected_product.map(function (item) {
        let pv_ID = item.product_var_id;
        addToCartData.push({ id: pv_ID, quantity: 1 });
      });




      var from = $(this).closest('form');
      addToCartCustom(from);

    
        // alert("Click add to cart Button")
          // addToCartBTN.click();
        $(".custom_addToCartBtn .loading-overlay__spinner, .atc_btn .loading-overlay__spinner").addClass("hidden")
        customAddToCartBTN.disabled = false;
        atc_btn.disabled = false;
    });
  });

  $(document).on('click', '[bundle-product-add]', function (e) {
    handleAddButtonClick(e);
  });
  $(document).on('click', '[slot-clear-btn]', function (e) {
    handleClearButtonClick(e);
  });
  $(document).on('click', '[sticky-clear-btn]', function (e) {
    clickslotClearBtns(e);
  });
  $(document).on('click', '.atc_btn', function () {
    customAddToCartBTN.click();
  });

  // Sticky Add To Cart Button JS
  const atcText = $('.build_own_bundle_section .product-form__submit').text().trim();
  $('.atc_btn .atc_text').text(atcText);
  const priceContainer = $('.build_own_bundle_section .price');
  const isProductOnSale = priceContainer.hasClass('price--on-sale');
  const regularPriceElement = isProductOnSale ? priceContainer.find('.custom_price__sale .price-item--regular') : priceContainer.find('.price__regular .price-item--regular');
  const salePriceElement = isProductOnSale ? priceContainer.find('.custom_price__sale .price-item--sale') : undefined;
  const regularPrice = regularPriceElement.text().trim().replace(' USD', '');
  $('.atc_btn .atc_sale_price').text(regularPrice);
  
  if (isProductOnSale) {
    const salePrice = salePriceElement.text().trim().replace(' USD', '');
    $('.atc_btn .atc_sale_price').text(salePrice).addClass('on_sale');
    $('.atc_btn .atc_regular_price').text(`(${regularPrice})`);
  } else {
    $('.atc_btn .atc_sale_price').removeClass('on_sale');
    $('.atc_btn .atc_regular_price').text('');
  }


     function findDuplicates(arr) {
         return arr.filter((currentValue, currentIndex) =>
         arr.indexOf(currentValue) !== currentIndex);
      }


  // Disable the button
  customAddToCartBTN.disabled = true;
  addToCartBTN.disabled = true;
  atc_btn.disabled = true;

  const handleAddButtonClick = (e) => {


    const stickyBundleSlots = buildOwnBundleSection.querySelectorAll('.sticky_slot_images .slot_image');
    const bundleSlots = buildOwnBundleSection.querySelectorAll('.slot_image_block .slot_image');
    const lineItemProperty = buildOwnBundleSection.querySelectorAll('.product_line_item_property');
    const { addCount, productId, productImg, productTitle, productFlavor, productSku, productVarId } = e.currentTarget.dataset;

    const sticky_eSlot = Array.from(stickyBundleSlots).find((e_slot) => e_slot.classList.contains('empty'));
    if (sticky_eSlot) {
      sticky_eSlot.classList.replace('empty', 'filled');
      sticky_eSlot.dataset.productId = productId;
      sticky_eSlot.dataset.productTitle = productTitle;
      sticky_eSlot.dataset.productTitle = productTitle;
      sticky_eSlot.children[1].innerText = productFlavor;

  

      const empty_SlotImg = sticky_eSlot.children[0];
      empty_SlotImg.src = productImg;
      empty_SlotImg.alt = productTitle;
    }

  

    if ($('.sticky_slot_images .slot_image.filled').length == 0) {
      $('.atc_sticky_block .slot_images').addClass('slot_empty_now');
    } else {
      $('.atc_sticky_block .slot_images').removeClass('slot_empty_now');
    }


    const eSlot = Array.from(bundleSlots).find((slot) => slot.classList.contains('empty'));
    if (eSlot) {

      var object = {
          "product_id": productId,
          "product_title": productTitle,
          "count": 0
      }

      console.log("selected_product object tress__:", object);

     productArray.push(object);

      eSlot.classList.replace('empty', 'filled');
      eSlot.dataset.productId = productId;
      eSlot.dataset.productTitle = productTitle;
      const eSlotImg = eSlot.children[0];
      eSlotImg.src = productImg;
      eSlotImg.alt = productTitle;

      var current_porudct_id = e.target.getAttribute('data-product-id');


 

      const count = productArray.filter(element => {
          if (element.product_id == current_porudct_id) {
            return true;
          }
          return false;
        }).length;


        const resultsArry = [...new Map(productArray.map((m) => [m.product_id, m])).values()];


        console.log("ProductArray  tress__:", productArray);
        console.log("resultsArry  tress__:", resultsArry);

        eSlot.dataset.productCount = count;
        var _pvgid = '_pvgid://shopify/ProductVariant/'+productVarId


      if (document.querySelectorAll('.slot_image.empty').length <= 0 && atc_btn_text != 'Sold out') {
        customAddToCartBTN.disabled = false;
        addToCartBTN.disabled = false;
        atc_btn.disabled = false;
      }

      product_data = {
        product_id: productId,
        product_var_id: productVarId,
        product_title: productTitle,
        product_sku: productSku,
        product_flavors_name: productFlavor,
        product_img: productImg,
        product_count: parseInt(count),
        _pvgid: _pvgid
      };
      selected_product.push(product_data);


        const results = [...new Map(selected_product.map((m) => [m.product_id, m])).values()];

         console.log("selected_product tress__:", selected_product);
         console.log("unique tress__:", results);

        var item_property_titles = $('#line_item_property input.product_line_item_property');
        var item_property_pvgids = $('#line_item_property input.product_line_pvgid');



        var index = 1;
              for (let i = 0; i < results.length; i++) {
            
                var position  = $(item_property_titles[i]).data('position');
                var pvgid_position  = $(item_property_pvgids[i]).data('pvgid-position');

                if(position === index){
                item_property_titles[i].id = `bundle-pItemName_${results[i].product_id}`;
                item_property_titles[i].value = parseInt(results[i].product_count);
                item_property_titles[i].name = 'properties['+ results[i].product_title+']';
                }else{
                  item_property_titles[i].id = `bundle-pItemName_${results[i].product_id}`;
                  item_property_titles[i].value = parseInt(results[i].product_count);
                  item_property_titles[i].name = 'properties['+ results[i].product_title+']';
                }

                if(pvgid_position === index){
                  item_property_pvgids[i].id = `bundle-pvgid_${results[i].product_id}`;
                  item_property_pvgids[i].value = parseInt(results[i].product_count);
                  item_property_pvgids[i].name = 'properties['+ results[i]._pvgid+']';
                }else{
                  item_property_pvgids[i].id = `bundle-pvgid_${results[i].product_id}`;
                  item_property_pvgids[i].value = parseInt(results[i].product_count);
                  item_property_pvgids[i].name = 'properties['+ results[i]._pvgid+']';
                }

                index = index++;

              }


              
    }
  };



  function arrayRemove(arr, value) { 
    return arr.filter(function(ele){ 
        return ele != value; 
    });
}

  const handleClearButtonClick = (e) => {
    const btnParent = e.currentTarget.parentNode;
    let remove_product_id = btnParent.dataset.productId;


    let removed = false;
    selected_product = selected_product.filter((product) => {
      if (product.product_id === remove_product_id && !removed) {
        removed = true;
        return false;
      }
      return true;
    });


    const countafter = selected_product.filter(element => {
          if (element.product_id == remove_product_id) {
            return true;
          }
          return false;
        }).length;

        selected_product = selected_product.map(element => {
            if (element.product_id === remove_product_id) {
                return { ...element, product_count: countafter };
            }
            return element;
        });

      
        let removedp = false;
        productArray = productArray.filter((product) => {
          if (product.product_id === remove_product_id && !removedp) {
            removedp = true;
            return false;
          }
          return true;
        });

      empty(productArray);

      selected_product.map(element => {
      productArray.push({
          "product_id": element.product_id,
          "product_title": element.product_title,
          "count": element.product_count
      })
      });


      console.log("after  remve selected_product:", selected_product);
      console.log("after  remve productArray:", productArray);

 
    const removeresults = [...new Map(selected_product.map((m) => [m.product_id, m])).values()];

    ResetAllInputLineitem(removeresults);

   
    // const product_input = document.getElementById(`bundle-pItemName_${btnParent.dataset.productId}`);
    //  product_input.classList.replace('filled', 'empty');
    // product_input.id = '';
    // product_input.value = '';

    btnParent.classList.replace('filled', 'empty');
    btnParent.dataset.productId = '';
    btnParent.dataset.productTitle = '';
    const eSlotImg = btnParent.children[0];
    eSlotImg.src = 'https://cdn.shopify.com/s/files/1/0572/5031/6486/files/Bundle_bg_singal.png?v=1697434607';
    eSlotImg.alt = '';




    // Sticky Btn
    const StickyBtn = e.currentTarget;
    const btnId = StickyBtn.attributes['data_slotbtn-id'].value;
    const sticky_sloat = document.querySelector(`[data_sticky-id="${btnId}"]`);

    sticky_sloat.classList.replace('filled', 'empty');
    sticky_sloat.dataset.productId = '';
    sticky_sloat.dataset.productTitle = '';
    sticky_sloat.children[1].innerText = '';
    const sticky_SlotImg = sticky_sloat.children[0];
    sticky_SlotImg.src = '';
    sticky_SlotImg.alt = '';

    if ($('.sticky_slot_images .slot_image.filled').length == 0) {
      $('.atc_sticky_block .slot_images').addClass('slot_empty_now');
    } else {
      $('.atc_sticky_block .slot_images').removeClass('slot_empty_now');
    }

    if (document.querySelectorAll('.slot_image.empty').length <= 0 && atc_btn_text != 'Sold out') {
      customAddToCartBTN.disabled = false;
      addToCartBTN.disabled = false;
      atc_btn.disabled = false;
    } else {
      customAddToCartBTN.disabled = true;
      addToCartBTN.disabled = true;
      atc_btn.disabled = true;
    }
  };

  const clickslotClearBtns = (e) => {
    const btn = e.currentTarget;
    const btnId = btn.attributes['data_stickybtn-id'].value;
    const sloat_btn = document.querySelector(`[data_slotbtn-id="${btnId}"]`);
    sloat_btn.click();

    const btnParent = e.currentTarget.parentNode;
    btnParent.classList.replace('filled', 'empty');
    btnParent.dataset.productId = '';
    btnParent.dataset.productTitle = '';
    btnParent.children[1].innerText = '';
    const eSlotImg = btnParent.children[0];
    eSlotImg.src = '';
    eSlotImg.alt = '';

    if ($('.sticky_slot_images .slot_image.filled').length == 0) {
      $('.atc_sticky_block .slot_images').addClass('slot_empty_now');
    } else {
      $('.atc_sticky_block .slot_images').removeClass('slot_empty_now');
    }
  };
  // console.log(' ================== Bundle Code END 1 ================== ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build_own_bundle_new"] && !Shopify.designMode) return;
  try {
    
  console.log(' ================== Bundle Code Start 101 ================== ');
  // Check if there are elements with the class .save_badge
  $( ".build_own_bundle_section .save_badge" ).prependTo( ".build_own_bundle_section .price .price__container" );

  const buildOwnBundleSection = document.querySelector('.build_own_bundle_section');

  const addToCartBTN = buildOwnBundleSection.querySelector('.product-form__buttons .product-form__submit');
  const atc_btn_text = $(".build_own_bundle_section .product-form__submit").text().trim();
  // const regularPrice = document.querySelector('.build_own_bundle_section .price-item--regular').innerText;
  // const SalePrice = document.querySelector('.build_own_bundle_section .price--on-sale .price-item--sale') ? document.querySelector('.build_own_bundle_section .price--on-sale .price-item--sale').innerText : '';
  const atc_btn = buildOwnBundleSection.querySelector('.atc_btn');

  $(document).on('click', '[bundle-product-add]', function (e) {handleAddButtonClick(e);});
  $(document).on('click', '[slot-clear-btn]', function (e) {handleClearButtonClick(e);});
  $(document).on('click', '[sticky-clear-btn]', function (e) {clickslotClearBtns(e);});
  $(document).on('click', '.atc_btn', function () {addToCartBTN.click();});

  $(".atc_btn .atc_text").text($(".build_own_bundle_section .product-form__submit").text().trim());
  let CheckProductSale = $(".build_own_bundle_section .price.price--large").hasClass("price--on-sale") ? true : false;
  if (CheckProductSale) {
    let regularPrice = $(".build_own_bundle_section .price__sale .price-item--regular").text().trim();
    $(".atc_btn .atc_regular_price").text(regularPrice);
    let salePrice = $(".build_own_bundle_section .price__sale .price-item--sale").text().trim();
    $(".atc_btn .atc_sale_price ").text(salePrice);
    $(".atc_btn .atc_sale_price ").addClass("on_sale");
  } else {
    $(".atc_btn .atc_sale_price ").removeClass("on_sale");
    let regularPrice = $(".build_own_bundle_section .price__regular .price-item--regular").text().trim();
    $(".atc_btn .atc_sale_price").text(regularPrice);
    $(".atc_btn .atc_regular_price").text('');
  }

// let regularPriceNew = $(".build_own_bundle_section .price__sale .price-item--regular").text().trim() !== "" ? $(".build_own_bundle_section .price__sale .price-item--regular").text().trim() : $(".build_own_bundle_section .price__regular .price-item--regular").text().trim();
// $(".atc_btn .atc_regular_price").text(regularPriceNew);
// atc_btn.childNodes[5].innerText = regularPrice; // Regular Price

  // if (SalePrice != '') {
  //   atc_btn.childNodes[3].classList.add('on_sale');
  //   atc_btn.childNodes[3].innerText = SalePrice; // Sale Price
  // }

  // Disable the button
  addToCartBTN.disabled = true;
  atc_btn.disabled = true;

  const handleAddButtonClick = (e) => {
    console.log('EVENT = handleAddButtonClick');

    const stickyBundleSlots = buildOwnBundleSection.querySelectorAll('.sticky_slot_images .slot_image');
    const bundleSlots = buildOwnBundleSection.querySelectorAll('.slot_image_block .slot_image');
    const lineItemProperty = buildOwnBundleSection.querySelectorAll('.product_line_item_property');
    const { productId, productImg, productTitle, productFlavor } = e.currentTarget.dataset;

    // console.log('stickyBundleSlots = ', stickyBundleSlots);
    const sticky_eSlot = Array.from(stickyBundleSlots).find((e_slot) => e_slot.classList.contains('empty'));
    // console.log('sticky_eSlot ===> ', sticky_eSlot);

    if (sticky_eSlot) {
      // console.log('sticky_eSlot - TRUE');
      sticky_eSlot.classList.replace('empty', 'filled');
      sticky_eSlot.dataset.productId = productId;
      sticky_eSlot.dataset.productTitle = productTitle;
      sticky_eSlot.children[1].innerText = productFlavor;
      const empty_SlotImg = sticky_eSlot.children[0];
      empty_SlotImg.src = productImg;
      empty_SlotImg.alt = productTitle;
    }

    // console.log('bundleSlots = ', bundleSlots);
    const eSlot = Array.from(bundleSlots).find((slot) => slot.classList.contains('empty'));
    // console.log('eSlot ===> ', eSlot);

    if (eSlot) {
      // console.log('eSlot - TRUE');
      eSlot.classList.replace('empty', 'filled');
      eSlot.dataset.productId = productId;
      eSlot.dataset.productTitle = productTitle;
      const eSlotImg = eSlot.children[0];
      eSlotImg.src = productImg;
      eSlotImg.alt = productTitle;

      for (const productInput of lineItemProperty) {
        if (productInput.classList.contains('empty')) {
          productInput.classList.replace('empty', 'filled');
          productInput.id = `bundle-pItemName_${productId}`;
          productInput.value = productTitle;
          break;
        }
      }

      if (document.querySelectorAll('.slot_image.empty').length <= 0 && atc_btn_text != 'Sold out') {
        addToCartBTN.disabled = false;
        atc_btn.disabled = false;
      }
    }
  };

  const handleClearButtonClick = (e) => {
    console.log('EVENT = handleClearButtonClick');
    const btnParent = e.currentTarget.parentNode;
    const product_input = document.getElementById(`bundle-pItemName_${btnParent.dataset.productId}`);
    product_input.classList.replace('filled', 'empty');
    product_input.id = '';
    product_input.value = '';
    btnParent.classList.replace('filled', 'empty');
    btnParent.dataset.productId = '';
    btnParent.dataset.productTitle = '';
    const eSlotImg = btnParent.children[0];
    eSlotImg.src = 'https://cdn.shopify.com/s/files/1/0572/5031/6486/files/Bundle_bg_singal.png?v=1697434607';
    eSlotImg.alt = '';

    // Sticky Btn
    const StickyBtn = e.currentTarget;
    const btnId = StickyBtn.attributes['data_slotbtn-id'].value;
    const sticky_sloat = document.querySelector(`[data_sticky-id="${btnId}"]`);

    sticky_sloat.classList.replace('filled', 'empty');
    sticky_sloat.dataset.productId = '';
    sticky_sloat.dataset.productTitle = '';
    sticky_sloat.children[1].innerText = '';
    const sticky_SlotImg = sticky_sloat.children[0];
    sticky_SlotImg.src = '';
    sticky_SlotImg.alt = '';

    if (document.querySelectorAll('.slot_image.empty').length <= 0 && atc_btn_text != 'Sold out') {
      addToCartBTN.disabled = false;
      atc_btn.disabled = false;
    } else {
      addToCartBTN.disabled = true;
      atc_btn.disabled = true;
    }
  };

  const clickslotClearBtns = (e) => {
    console.log('EVENT = clickslotClearBtns');
    const btn = e.currentTarget;
    const btnId = btn.attributes['data_stickybtn-id'].value;
    const sloat_btn = document.querySelector(`[data_slotbtn-id="${btnId}"]`);
    sloat_btn.click();

    const btnParent = e.currentTarget.parentNode;
    btnParent.classList.replace('filled', 'empty');
    btnParent.dataset.productId = '';
    btnParent.dataset.productTitle = '';
    btnParent.children[1].innerText = '';
    const eSlotImg = btnParent.children[0];
    eSlotImg.src = '';
    eSlotImg.alt = '';
  };
  console.log(' ================== Bundle Code END 0 ================== ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build_own_bundle_new_two"] && !Shopify.designMode) return;
  try {
    
  // console.log(' ================== Bundle Code Start 1  ================== ');
  const setVariant = setInterval(function () {
    $('.build_own_bundle_section .slot_toggle #slot_toggle_pack_1').click();
  }, 50);
  setTimeout(function () {
    clearInterval(setVariant);
  }, 2000);

  // Update the Bundle Product review Count
  function reviewSet() {
    if ($('.shopify-block.shopify-app-block .loox-trust-badge-widget-ratings__raters-count').length !== 0) {
      const app_reviewCount = $('.shopify-block.shopify-app-block .loox-trust-badge-widget-ratings__raters-count').text();
      $('.bundle_product_review .loox-rating-label').text(`(${app_reviewCount})`);
      $('.customer_reviews_sec .customers-btn .review_count').text(app_reviewCount);
      clearInterval(intervalId);
    }
  }
  const intervalId = setInterval(reviewSet, 1000);
  setTimeout(function () {
    clearInterval(intervalId);
  }, 10000);

  // Check if there are elements with the class .save_badge
  // $('.build_own_bundle_section .save_badge').prependTo('.build_own_bundle_section .price .price__container');

  const buildOwnBundleSection = document.querySelector('.build_own_bundle_section');
  const customAddToCartBTN = document.querySelector('.build_own_bundle_section .custom_addToCartBtn');
  const addToCartBTN = document.querySelector('.build_own_bundle_section .product-form__submit');
  const atc_btn_text = $('.build_own_bundle_section .product-form__submit').text().trim();
  const atc_btn = document.querySelector('.build_own_bundle_section .atc_btn');

  // Define a function that returns a promise for the AJAX call
  function addToCartAsync(items) {
    //return new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: 'https://' + window.mu_origin + '/cart/add.js',
        data: JSON.stringify({ items: items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function (response) {
          // alert("Items Added");
          addToCartBTN.click();
          $(".custom_addToCartBtn .loading-overlay__spinner, .atc_btn .loading-overlay__spinner").addClass("hidden")
          customAddToCartBTN.disabled = false;
          // addToCartBTN.disabled = false;
          atc_btn.disabled = false;
          //resolve(response);
        },
        error: function (xhr, textStatus, errorThrown) {
          // alert("Get Error!");
          reject({ textStatus, errorThrown, response: xhr.responseText });
        }
      });
   // });
  }


  function addToCartCustom(from) {
    const resultsproduct = [...new Map(selected_product.map((m) => [m.product_id, m])).values()];
    var product_vid = from.find('input[name="id"]').val();
    var selling_plan = from.find('input[name="selling_plan"]').val();




        if(resultsproduct[0] != null ){

        var product_title_1 = resultsproduct[0].product_title
        var _pvgid_1 = resultsproduct[0]._pvgid
        var product_count_1 = resultsproduct[0].product_count

        }
       if( resultsproduct[1] != null){

        var product_title_2 = resultsproduct[1].product_title
        var _pvgid_2 = resultsproduct[1]._pvgid
        var product_count_2 = resultsproduct[1].product_count

        } 
        
        if( resultsproduct[2] != null){

          var product_title_3 = resultsproduct[2].product_title
          var _pvgid_3 = resultsproduct[2]._pvgid
          var product_count_3 = resultsproduct[2].product_count

        }
        
        if( resultsproduct[3] != null){

            var product_title_4 = resultsproduct[3].product_title
            var _pvgid_4 = resultsproduct[3]._pvgid
            var product_count_4 = resultsproduct[3].product_count

        }
        
        if( resultsproduct[4] != null){

              var product_title_5 = resultsproduct[4].product_title
              var _pvgid_5 = resultsproduct[4]._pvgid
              var product_count_5 = resultsproduct[4].product_count

            }


      var data = {
          [product_title_1] : product_count_1,
          [_pvgid_1] : product_count_1,

          [product_title_2] : product_count_2,
          [_pvgid_2] : product_count_2,

          [product_title_3] : product_count_3,
          [_pvgid_3] : product_count_3,

          [product_title_4] : product_count_4,
          [_pvgid_4] : product_count_4,

          [product_title_5] : product_count_5,
          [_pvgid_5] : product_count_5
  
      }



      let formData = {};

       if(selling_plan > 0){

       formData = {
        'id':  parseInt(product_vid, 10),
        'quantity': 1,
        "selling_plan" : selling_plan,
        'properties': data
       };


       }else{
      formData = {
              'id':  parseInt(product_vid, 10),
              'quantity': 1,
              'properties': data
            };

       }


       var items = [];
       items.push(formData);


      $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          data: JSON.stringify({ items: items }),
          contentType: 'application/json',
          dataType: 'json', 
          success: function(data) {
            const monster_active = !!document.querySelector('script[src*="/cart_renderer."]');
          if(monster_active) window.monster_refresh();
          openCart();


          },
          error: 'addToCartFail'
      });



  }






  $(document).ready(function () {
    let sellingPlanID = document.getElementById('sellingPlanData').dataset.sellingPlanId;
    $(`[name="selling_plan"]`).val(sellingPlanID);
    $('[name="selling_plan"]').prop('disabled', false);
      
    $(".build_own_bundle_section .custom_addToCartBtn").on("click", async function () {
      customAddToCartBTN.disabled = true;
      // addToCartBTN.disabled = true;
      atc_btn.disabled = true;
      $(".custom_addToCartBtn .loading-overlay__spinner, .atc_btn .loading-overlay__spinner").removeClass("hidden")
      let addToCartData = [];
      selected_product.map(function (item) {
        let pv_ID = item.product_var_id;
        addToCartData.push({ id: pv_ID, quantity: 1 });
      });




      var from = $(this).closest('form');
      addToCartCustom(from);

    
        // alert("Click add to cart Button")
          // addToCartBTN.click();
        $(".custom_addToCartBtn .loading-overlay__spinner, .atc_btn .loading-overlay__spinner").addClass("hidden")
        customAddToCartBTN.disabled = false;
        atc_btn.disabled = false;
    });
  });

  $(document).on('click', '[bundle-product-add]', function (e) {
    handleAddButtonClick(e);
  });
  $(document).on('click', '[slot-clear-btn]', function (e) {
    handleClearButtonClick(e);
  });
  $(document).on('click', '[sticky-clear-btn]', function (e) {
    clickslotClearBtns(e);
  });
  $(document).on('click', '.atc_btn', function () {
    customAddToCartBTN.click();
  });

  // Sticky Add To Cart Button JS
  const atcText = $('.build_own_bundle_section .product-form__submit').text().trim();
  $('.atc_btn .atc_text').text(atcText);
  const priceContainer = $('.build_own_bundle_section .price');
  const isProductOnSale = priceContainer.hasClass('price--on-sale');
  const regularPriceElement = isProductOnSale ? priceContainer.find('.custom_price__sale .price-item--regular') : priceContainer.find('.price__regular .price-item--regular');
  const salePriceElement = isProductOnSale ? priceContainer.find('.custom_price__sale .price-item--sale') : undefined;
  const regularPrice = regularPriceElement.text().trim().replace(' USD', '');
  $('.atc_btn .atc_sale_price').text(regularPrice);
  
  if (isProductOnSale) {
    const salePrice = salePriceElement.text().trim().replace(' USD', '');
    $('.atc_btn .atc_sale_price').text(salePrice).addClass('on_sale');
    $('.atc_btn .atc_regular_price').text(`(${regularPrice})`);
  } else {
    $('.atc_btn .atc_sale_price').removeClass('on_sale');
    $('.atc_btn .atc_regular_price').text('');
  }


     function findDuplicates(arr) {
         return arr.filter((currentValue, currentIndex) =>
         arr.indexOf(currentValue) !== currentIndex);
      }


  // Disable the button
  customAddToCartBTN.disabled = true;
  addToCartBTN.disabled = true;
  atc_btn.disabled = true;

  const handleAddButtonClick = (e) => {


    const stickyBundleSlots = buildOwnBundleSection.querySelectorAll('.sticky_slot_images .slot_image');
    const bundleSlots = buildOwnBundleSection.querySelectorAll('.slot_image_block .slot_image');
    const lineItemProperty = buildOwnBundleSection.querySelectorAll('.product_line_item_property');
    const { addCount, productId, productImg, productTitle, productFlavor, productSku, productVarId } = e.currentTarget.dataset;

    const sticky_eSlot = Array.from(stickyBundleSlots).find((e_slot) => e_slot.classList.contains('empty'));
    if (sticky_eSlot) {
      sticky_eSlot.classList.replace('empty', 'filled');
      sticky_eSlot.dataset.productId = productId;
      sticky_eSlot.dataset.productTitle = productTitle;
      sticky_eSlot.dataset.productTitle = productTitle;
      sticky_eSlot.children[1].innerText = productFlavor;

  

      const empty_SlotImg = sticky_eSlot.children[0];
      empty_SlotImg.src = productImg;
      empty_SlotImg.alt = productTitle;
    }

  

    if ($('.sticky_slot_images .slot_image.filled').length == 0) {
      $('.atc_sticky_block .slot_images').addClass('slot_empty_now');
    } else {
      $('.atc_sticky_block .slot_images').removeClass('slot_empty_now');
    }


    const eSlot = Array.from(bundleSlots).find((slot) => slot.classList.contains('empty'));
    if (eSlot) {

      var object = {
          "product_id": productId,
          "product_title": productTitle,
          "count": 0
      }

      console.log("selected_product object tress__:", object);

     productArray.push(object);

      eSlot.classList.replace('empty', 'filled');
      eSlot.dataset.productId = productId;
      eSlot.dataset.productTitle = productTitle;
      const eSlotImg = eSlot.children[0];
      eSlotImg.src = productImg;
      eSlotImg.alt = productTitle;

      var current_porudct_id = e.target.getAttribute('data-product-id');


 

      const count = productArray.filter(element => {
          if (element.product_id == current_porudct_id) {
            return true;
          }
          return false;
        }).length;


        const resultsArry = [...new Map(productArray.map((m) => [m.product_id, m])).values()];


        console.log("ProductArray  tress__:", productArray);
        console.log("resultsArry  tress__:", resultsArry);

        eSlot.dataset.productCount = count;
        var _pvgid = '_pvgid://shopify/ProductVariant/'+productVarId


      if (document.querySelectorAll('.slot_image.empty').length <= 0 && atc_btn_text != 'Sold out') {
        customAddToCartBTN.disabled = false;
        addToCartBTN.disabled = false;
        atc_btn.disabled = false;
      }

      product_data = {
        product_id: productId,
        product_var_id: productVarId,
        product_title: productTitle,
        product_sku: productSku,
        product_flavors_name: productFlavor,
        product_img: productImg,
        product_count: parseInt(count),
        _pvgid: _pvgid
      };
      selected_product.push(product_data);


        const results = [...new Map(selected_product.map((m) => [m.product_id, m])).values()];

         console.log("selected_product tress__:", selected_product);
         console.log("unique tress__:", results);

        var item_property_titles = $('#line_item_property input.product_line_item_property');
        var item_property_pvgids = $('#line_item_property input.product_line_pvgid');



        var index = 1;
              for (let i = 0; i < results.length; i++) {
            
                var position  = $(item_property_titles[i]).data('position');
                var pvgid_position  = $(item_property_pvgids[i]).data('pvgid-position');

                if(position === index){
                item_property_titles[i].id = `bundle-pItemName_${results[i].product_id}`;
                item_property_titles[i].value = parseInt(results[i].product_count);
                item_property_titles[i].name = 'properties['+ results[i].product_title+']';
                }else{
                  item_property_titles[i].id = `bundle-pItemName_${results[i].product_id}`;
                  item_property_titles[i].value = parseInt(results[i].product_count);
                  item_property_titles[i].name = 'properties['+ results[i].product_title+']';
                }

                if(pvgid_position === index){
                  item_property_pvgids[i].id = `bundle-pvgid_${results[i].product_id}`;
                  item_property_pvgids[i].value = parseInt(results[i].product_count);
                  item_property_pvgids[i].name = 'properties['+ results[i]._pvgid+']';
                }else{
                  item_property_pvgids[i].id = `bundle-pvgid_${results[i].product_id}`;
                  item_property_pvgids[i].value = parseInt(results[i].product_count);
                  item_property_pvgids[i].name = 'properties['+ results[i]._pvgid+']';
                }

                index = index++;

              }


              
    }
  };



  function arrayRemove(arr, value) { 
    return arr.filter(function(ele){ 
        return ele != value; 
    });
}

  const handleClearButtonClick = (e) => {
    const btnParent = e.currentTarget.parentNode;
    let remove_product_id = btnParent.dataset.productId;


    let removed = false;
    selected_product = selected_product.filter((product) => {
      if (product.product_id === remove_product_id && !removed) {
        removed = true;
        return false;
      }
      return true;
    });


    const countafter = selected_product.filter(element => {
          if (element.product_id == remove_product_id) {
            return true;
          }
          return false;
        }).length;

        selected_product = selected_product.map(element => {
            if (element.product_id === remove_product_id) {
                return { ...element, product_count: countafter };
            }
            return element;
        });

      
        let removedp = false;
        productArray = productArray.filter((product) => {
          if (product.product_id === remove_product_id && !removedp) {
            removedp = true;
            return false;
          }
          return true;
        });

      empty(productArray);

      selected_product.map(element => {
      productArray.push({
          "product_id": element.product_id,
          "product_title": element.product_title,
          "count": element.product_count
      })
      });


      console.log("after  remve selected_product:", selected_product);
      console.log("after  remve productArray:", productArray);

 
    const removeresults = [...new Map(selected_product.map((m) => [m.product_id, m])).values()];

    ResetAllInputLineitem(removeresults);

   
    // const product_input = document.getElementById(`bundle-pItemName_${btnParent.dataset.productId}`);
    //  product_input.classList.replace('filled', 'empty');
    // product_input.id = '';
    // product_input.value = '';

    btnParent.classList.replace('filled', 'empty');
    btnParent.dataset.productId = '';
    btnParent.dataset.productTitle = '';
    const eSlotImg = btnParent.children[0];
    eSlotImg.src = 'https://cdn.shopify.com/s/files/1/0572/5031/6486/files/Bundle_bg_singal.png?v=1697434607';
    eSlotImg.alt = '';




    // Sticky Btn
    const StickyBtn = e.currentTarget;
    const btnId = StickyBtn.attributes['data_slotbtn-id'].value;
    const sticky_sloat = document.querySelector(`[data_sticky-id="${btnId}"]`);

    sticky_sloat.classList.replace('filled', 'empty');
    sticky_sloat.dataset.productId = '';
    sticky_sloat.dataset.productTitle = '';
    sticky_sloat.children[1].innerText = '';
    const sticky_SlotImg = sticky_sloat.children[0];
    sticky_SlotImg.src = '';
    sticky_SlotImg.alt = '';

    if ($('.sticky_slot_images .slot_image.filled').length == 0) {
      $('.atc_sticky_block .slot_images').addClass('slot_empty_now');
    } else {
      $('.atc_sticky_block .slot_images').removeClass('slot_empty_now');
    }

    if (document.querySelectorAll('.slot_image.empty').length <= 0 && atc_btn_text != 'Sold out') {
      customAddToCartBTN.disabled = false;
      addToCartBTN.disabled = false;
      atc_btn.disabled = false;
    } else {
      customAddToCartBTN.disabled = true;
      addToCartBTN.disabled = true;
      atc_btn.disabled = true;
    }
  };

  const clickslotClearBtns = (e) => {
    const btn = e.currentTarget;
    const btnId = btn.attributes['data_stickybtn-id'].value;
    const sloat_btn = document.querySelector(`[data_slotbtn-id="${btnId}"]`);
    sloat_btn.click();

    const btnParent = e.currentTarget.parentNode;
    btnParent.classList.replace('filled', 'empty');
    btnParent.dataset.productId = '';
    btnParent.dataset.productTitle = '';
    btnParent.children[1].innerText = '';
    const eSlotImg = btnParent.children[0];
    eSlotImg.src = '';
    eSlotImg.alt = '';

    if ($('.sticky_slot_images .slot_image.filled').length == 0) {
      $('.atc_sticky_block .slot_images').addClass('slot_empty_now');
    } else {
      $('.atc_sticky_block .slot_images').removeClass('slot_empty_now');
    }
  };
  // console.log(' ================== Bundle Code END 1 ================== ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  AOS.init()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
